export default percent => `${percent.toLocaleString()}%`
